import "./src/styles/custom.css"; 

export const onRouteUpdate = ({ location }) => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  };

  export const onInitialClientRender = () => {
    window.addEventListener('popstate', () => {
      window.scrollTo(0, 0);
    });
    
    // Load canvas.js only once to prevent redeclaration errors
    if (typeof window !== 'undefined' && !window.__canvasJsLoaded) {
      // Check if script already exists in DOM
      const existingScript = document.querySelector('script[src="/js/canvas.js"]');
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = '/js/canvas.js';
        script.async = true;
        script.onload = () => {
          window.__canvasJsLoaded = true;
        };
        script.onerror = () => {
          console.error('Failed to load canvas.js');
        };
        document.head.appendChild(script);
      } else {
        window.__canvasJsLoaded = true;
      }
    }
  };
